/**
=========================================================
* Material Dashboard 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
// import ReportsBarChart from "components/Charts/BarCharts/ReportsBarChart";
import ComplexStatisticsCard from "components/Cards/StatisticsCards/ComplexStatisticsCard";

// Dashboard components
// import Projects from "layouts/dashboard/components/Projects";
// import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import DefaultInfoCard from "components/Cards/InfoCards/DefaultInfoCard/index";
import CanAccess from "helpers/CanAccess";

function Dashboard() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <CanAccess roles={["ROLE_ADMIN", "ROLE_USER"]}>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="dark"
                  icon="weekend"
                  title="Clocked In"
                  count={0}
                  percentage={{
                    color: "success",
                    amount: "0%",
                    label: "than lask week",
                  }}
                />
              </MDBox>
            </Grid>
          </CanAccess>

          <CanAccess roles={["ROLE_ADMIN", "ROLE_USER"]}>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  icon="leaderboard"
                  title="Clocked out"
                  count="0"
                  percentage={{
                    color: "success",
                    amount: "0%",
                    label: "than last week",
                  }}
                />
              </MDBox>
            </Grid>
          </CanAccess>

          <CanAccess roles={["ROLE_ADMIN", "ROLE_USER"]}>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="success"
                  icon="store"
                  title="Meal Breaks"
                  count="0"
                  percentage={{
                    color: "secondary",
                    amount: "",
                    label: "No Change",
                  }}
                />
              </MDBox>
            </Grid>
          </CanAccess>

          <CanAccess roles={["ROLE_ADMIN", "ROLE_USER"]}>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="primary"
                  icon="person_add"
                  title="Total hours"
                  count="0"
                  percentage={{
                    color: "secondary",
                    amount: "",
                    label: "No Change",
                  }}
                />
              </MDBox>
            </Grid>
          </CanAccess>
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <CanAccess roles={["ROLE_ADMIN", "ROLE_USER"]}>
              <Grid item xs={12} md={6} lg={4}>
                <MDBox mb={3}>
                  <DefaultInfoCard
                    icon="account_balance"
                    title="current phones #'s"
                    description="active phone numbers"
                    value="0"
                  />
                </MDBox>
              </Grid>
            </CanAccess>
            <CanAccess roles={["ROLE_ADMIN", "ROLE_USER"]}>
              <Grid item xs={12} md={6} lg={4}>
                <MDBox mb={3}>
                  <DefaultInfoCard
                    icon="account_balance"
                    title="Current QR Code Locations"
                    description="active qr codes"
                    value="0"
                  />
                </MDBox>
              </Grid>
            </CanAccess>
            <CanAccess roles={["ROLE_ADMIN", "ROLE_USER"]}>
              <Grid item xs={12} md={6} lg={4}>
                <MDBox mb={3}>
                  <DefaultInfoCard
                    icon="account_balance"
                    title="Current tranmissions"
                    description="All tranmissions"
                    value="0"
                  />
                </MDBox>
              </Grid>
            </CanAccess>
          </Grid>
        </MDBox>
        {/* <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={8}>
              <Projects />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <OrdersOverview />
            </Grid>
          </Grid>
        </MDBox> */}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
